import React from "react";
import EmployeeInquiriesChart from "./EmployeeInquiriesChart";
import { EmployeeInquiryData } from "./types";

// import DashboardChart from "./DashboardChart";
// import { VerticalData } from "./types";

interface Props {
  verticalName: string;
  verticalKey: string;
  employees: EmployeeInquiryData[];
}

const ChartBox = ({ verticalName, verticalKey, employees }: Props) => {
  return (
    <div className="chart-card chart-card-fixed">
      <h4 className="chart-title">{verticalName} — Employee Inquiries</h4>
      <div className="chart-card-body">
        <EmployeeInquiriesChart
          employees={employees}
          verticalKey={verticalKey}
          verticalName={verticalName}
        />
      </div>
    </div>
  );
};

/* Previous vertical comparison chart:
const ChartBox = ({ data }: { data: VerticalData[] }) => {
  if (!data?.length) return null;

  return (
    <div className="chart-card">
      <h4 className="chart-title">
        {data.length === 1 ? data[0].vertical_name : "Vertical Comparison"}
      </h4>

      <DashboardChart data={data} />
    </div>
  );
};
*/

export default ChartBox;
